import * as Yup from 'yup';
import { stringValidation } from '../../../helpers';

export const validationSchema = Yup.object().shape({
  value: stringValidation('Value'),
});
